<template>
  <div class="">
    <div v-if="broker != null && ($store.state.user.id == broker.user_id || $store.state.user.role == 1)">

      <PageHeader :label="isUserThisBroker ? 'Payment Settings' : broker.first_name + ' ' + broker.last_name + ' Payment Settings'"></PageHeader>

      <div class="my-8 text-base">

        <template v-if="$store.state.brokerModule.broker.free_access">
          You have been granted <span class="font-semibold">free access</span>.
        </template>

        <template v-else>

            <template v-if="broker.subscription.stripe != null">
              <!--
                Subscription has been cancelled, but user is on grace period eg canclled on 5th May but Subscription acutally
                ends on 10th May. User still have 5 days remain with the subscription.
              -->
              <template v-if="broker.subscription.stripe.on_grace_period == true">
                You have cancelled your subscription 
                <span class="font-semibold text-blue-500">{{ broker.subscription.stripe.name }}</span> plan.
                Your subscription will end on
                <span class="font-semibold">{{ formatDate(broker.subscription.stripe.ends_at, 'YYYY-MM-DD', 'dddd, MMMM Do YYYY') }}</span>. 
                You have full access to 
                <span class="font-semibold text-blue-500">{{ broker.subscription.stripe.name }}</span> plan
                until this date.
              </template>

              <template v-else>
                You are currently on
                <span class="font-semibold text-blue-500 uppercase">{{ broker.subscription.stripe.name }}</span>
                subscription plan.

                <!-- <template v-if="broker.subscription.stripe.on_trial">
                  
                </template> -->

                You can change to 
                <span class="font-semibold text-blue-500">
                  {{ broker.subscription.stripe.name == 'Pro Plan' ? 'Standard Plan' : 'Pro Plan' }} Plan
                </span>
                or you
                
                <a href="#"
                   class="text-red-500 underline"
                   @click.prevent="cancelSubscription()">cancel this subscription</a>

                and move to the 
                <span class="font-semibold text-blue-500">Free Plan</span>.

                <div class="mt-4">
                  You can also 
                  <a href="#"
                     class="text-blue-500 underline"
                     @click.prevent="changeCard()">change your payment card details</a>

                  if you need to.
                </div>
              </template>
            </template>

            <template v-else>
              <template v-if="broker.trial_ended">
                <div class="text-base">
                  You are currently not subscribed to any plan.
                </div>
              </template>

              <template v-else>
                You are currently on our Trial Plan, which means you can access all of our features including those in our Standard
                and Pro plans. Your trial period ends on {{ broker.trial_end_date }}.
              </template>
            </template>

            <div class="flex flex-wrap -mx-4 mt-8">
              <div class="w-full lg:w-1/3 pr-0 lg:px-4">
                <FreePlan :subscription="broker.subscription.stripe" 
                  :cancelSubscription="cancelSubscription" />
              </div>

              <template v-for="(plan, index) in plans">
                <template v-if="plan.nickname == 'Standard Plan'">
                  <div class="w-full lg:w-1/3 pr-0 lg:px-4">
                    <StandardPlan :plan="plan" 
                      :subscription="broker.subscription.stripe" 
                      :subscribe="subscribe"
                      :resume="resume"
                      :switchPlan="switchPlan" />
                  </div>
                </template>
              </template>

              <template v-for="(plan, index) in plans">
                <template v-if="plan.nickname == 'Pro Plan'">
                  <div class="w-full lg:w-1/3 pr-0 lg:px-4">
                    <ProPlan :plan="plan" 
                      :subscription="broker.subscription.stripe" 
                      :subscribe="subscribe"
                      :resume="resume"
                      :switchPlan="switchPlan" />
                  </div>
                </template>
              </template>
            </div>

            <div class="mt-6 text-sm text-gray-600">
              * For information on what's included in each plan, please visit our 
              <a href="https://www.brokerpad.com.au/#pricing" class="text-blue-500 underline" target="_blank">pricing page</a>.
            </div>
        </template>
      </div>
    </div>

    <PaymentModal :broker="broker" />
    <ChangeCardModal :broker="broker" />
  </div>
</template>

<script>
  import moment             from "moment"
  import { EventBus }       from '@/shared/event-bus'
  import PageHeader         from '@/shared/components/headers/PageHeader'
  import PaymentModal       from './PaymentModal'
  import ChangeCardModal    from './ChangeCardModal'
  import FreePlan           from './FreePlan'
  import StandardPlan       from './StandardPlan'
  import ProPlan            from './ProPlan'
  import SubmitButton2      from '@/shared/components/form/SubmitButton2'

  export default {

    components: {
      PageHeader,
      PaymentModal,
      ChangeCardModal,
      FreePlan,
      StandardPlan,
      ProPlan,
      SubmitButton2
    },

    data () {
      return {
        broker      : null,
        subscription: null,
        plans       : null
      }
    },

    created() {
      this.apiGet({}, 'stripe/plans', (plans) => {
        this.plans = plans.data
      })
    },

    mounted() {
      this.getBrokerLocal()

      EventBus.$on('get-broker-local', () => {
        this.getBrokerLocal()
      })
    },

    beforeDestroy() {
      EventBus.$off('get-broker-local')
    },

    methods : {

      getBrokerLocal(callback = null) {
        this.showLoader("Getting data...")
        this.getBroker({
          brokerId: this.$route.params.brokerId,
          force   : true
        }, (broker) => {
          this.broker = broker
          this.hideLoader()

          if(callback != null) {
            callback()
          } 
        })
      },

      changeCard() {
        this.$modal.show('change-card-modal')
      },

      subscribe(plan) {
        this.$modal.show('payment-modal', {
          plan : plan
        })
      },

      resume() {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: `Resume your ${this.broker.subscription.stripe.name} plan?`,
          buttons:[{
            label          : 'Yes',
            color          : 'green',
            loadingViaLocal: true,
            action         : () => {
              this.apiPost({
                planName: this.broker.subscription.stripe.name
              }, 'stripe/resume', () => {
                this.$modal.hide('confirm-modal')
                this.getBrokerLocal()
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': `You have successfully resumed your ${this.broker.subscription.stripe.name} plan.`
                });
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },

      switchPlan(plan) {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: `Switch to ${plan.nickname} plan?`,
          buttons:[{
            label          : 'Yes',
            color          : 'green',
            loadingViaLocal: true,
            action         : () => {
              this.apiPost({
                currPlanName: this.broker.subscription.stripe.name,
                newPlanName : plan.nickname,
                newPlanId   : plan.id
              }, 'stripe/switch', () => {
                this.$modal.hide('confirm-modal')
                this.getBrokerLocal()
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': `Successfully changed to ${plan.nickname} plan.`
                });
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },

      cancelSubscription() {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to cancel this subscription? Once your current subscription ends, your plan will move to Free Plan.",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiPost({
                planName : this.broker.subscription.stripe.name
              }, 'stripe/cancel', () => {
                this.$modal.hide('confirm-modal')
                this.getBrokerLocal()
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': 'Plan successfully cancelled.'
                })
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },
    }
  }
</script>